module.exports = __webpack_public_path__ + "img/EnVision.c914517e.svg";